// SearchResultsGrid.js
import React from 'react';
import SearchResultCard from './SearchResultCard';
import { useSelector, useDispatch } from "react-redux";
import {Animate} from "react-simple-animate";
import {v4 as uuidv4} from "uuid";

import stripHtml from "../../Components/StripHTML";



const SearchResultsGrid = ({filteredResults, searchFilterType}) => {
    const {searchTerm, searchOrderByOldest, searchOrderByNewest} = useSelector(state => state.active)



    const sortedResults = React.useMemo(() => {
        const resultsCopy = [...filteredResults];

        resultsCopy.sort((a, b) => {
            // Assuming IDs are numeric and sequentially assigned, so newer items have higher IDs
            if (searchOrderByNewest) {
                // For newest first, compare IDs in descending order
                return b.id - a.id;
            } else if (searchOrderByOldest) {
                // For oldest first, compare IDs in ascending order
                return a.id - b.id;
            }

            return 0; // Default case, no sorting applied
        });

        return resultsCopy;
    }, [filteredResults, searchOrderByNewest, searchOrderByOldest]);



    return (
        <div className="grid xs:grid-cols-2 gap-4 lg:grid-cols-1">
            {sortedResults.length > 0 ? (
                sortedResults.map((filteredResult) =>
                    <SearchResultCard
                        key={uuidv4()} // Fixed to use uuidv4() for unique keys
                        title={stripHtml(filteredResult.title?.rendered ?? "")}
                        content={stripHtml(filteredResult.content.rendered) ?? ""}
                        date={filteredResult.date}
                        imgSrc={filteredResult?._embedded?.["wp:featuredmedia"]?.[0]?.source_url ?? "https://placeholder.co/275x225"}
                        type={searchFilterType}
                        id={filteredResult.id}
                        mediaId={filteredResult.id}
                        authorName={filteredResult?._embedded?.author?.[0]?.name ?? ""}
                        orientation={filteredResult?.acf?.orientation ?? null}
                        vidLink={filteredResult?.acf?.video_network === "vimeo" ? filteredResult?.acf?.vimeo_url ?? null : filteredResult?.acf?.youtube_url ?? null}
                        mediaType={filteredResult?.type ?? null}
                    />
                )
            ) : (
                <div className="text-center text-white">
                    No results found for "{searchTerm}"
                </div>
            )}
        </div>
    );
};

export default SearchResultsGrid;